import { i18nFilter } from "app/filters/i18nFilter";
import type * as React from "react";
import { AnalysisHomePage } from "./AnalysisHomePage";
import { AnalysisHomePageTrial } from "./AnalysisHomePageTrial/AnalysisHomePageTrial";
import { isNoTouch, isTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";

const translate = i18nFilter();

export const CompetitiveAnalysisHomepage: React.FC<{
    websitePageStateOverride?: string;
    title?: string;
    isWAHomePageTrial?: boolean;
}> = ({
    websitePageStateOverride,
    title = "aquisitionintelligence.competitiveanalysis.home.title",
    isWAHomePageTrial,
}) => {
    return isWAHomePageTrial && (isTrialOrAfterTrial() || !!isNoTouch()) ? (
        <AnalysisHomePageTrial websitePageStateOverride={websitePageStateOverride} />
    ) : (
        <AnalysisHomePage
            websitePageStateOverride={websitePageStateOverride}
            title={translate(title)}
            subTitle={translate("aquisitionintelligence.competitiveanalysis.home.subtitle")}
        />
    );
};
